import script from "./CertificationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationsView.vue?vue&type=script&setup=true&lang=js"

import "./CertificationsView.vue?vue&type=style&index=0&id=163f8553&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163f8553"]])

export default __exports__